
import axios from '@/helpers/_core/axios';
import CONST from '@/helpers/_core/const';

export default class Auth {
  static SERVICE_NAME = 'auth';

  constructor({ app }) {
    this.axios = axios(app);
    this.state = app.store.state._core;
  }

  /* =========== Sign In =========== */
  signIn(body, tenantAlias) {
    if (this.state.application.isOperation) {
      return this.signInOperation(body);
    }

    return this.signInTenant(body, tenantAlias);
  }

  checkToken() {
    return this.axios.withToken().get(`${CONST.API_SAFEA_AUTH}/token/check`);
  }

  signInTenant(body, tenantAlias) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_AUTH}/signin/tenants/${tenantAlias}`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  async signInOperation(body) {
    const { captcha } = body;
    delete body.captcha;
    return this.axios.default().post(`${CONST.API_SAFEA_AUTH}/signin/operations`, body, {
      headers: {
        'X-Aws-Waf-Token': captcha
      }
    });
  }

  signinSSOUrl(body, applicationAlias, { isAppLauncher } = {}) {
    return this.axios.withToken().post(`${CONST.API_SAFEA_AUTH}/sso/applications/${applicationAlias}/url`, body, {
      params: {
        appLauncher: isAppLauncher ? 'true' : 'false'
      }
    })
      .then(result => {
        return result;
      });
  }

  /* =========== Assume Role =========== */
  assumeRole(tenantAlias, iesAlias, body) {
    return this.axios.withToken().put(`${CONST.API_SAFEA_AUTH}/role/assume`, {
      ...body,
      tenantAlias,
      iesAlias
    });
  }

  /** @deprecated Use assumeRole instead */
  assumeRoleTenantWithIes(tenantAlias, iesAlias, body) {
    return this.axios.withToken().put(`${CONST.API_SAFEA_AUTH}/role/assume/tenants/${tenantAlias}/ies/${iesAlias}`, body);
  }

  /** @deprecated Use assumeRole instead */
  assumeRoleTenant(tenantAlias, body) {
    return this.axios.withToken().put(`${CONST.API_SAFEA_AUTH}/role/assume/tenants/${tenantAlias}`, body);
  }

  /** @deprecated Use assumeRole instead */
  assumeRoleAplication(body) {
    return this.axios.withToken().put(`${CONST.API_SAFEA_AUTH}/role/assume/application`, body);
  }

  /* =========== Sign out ================= */
  signOutSaml() {
    return this.axios.withToken().get(`${CONST.API_SAFEA_AUTH}/sso/saml/logout`);
  }

  /* ============ Impersonate ============= */
  impersonate(body) {
    return this.axios.withToken().post(`${CONST.API_SAFEA_AUTH}/signin/impersonate`, body);
  }
}
